import { Injectable } from '@angular/core';
import { tAdminConfig, tResourceTypeMapping, tSupportedVETypeListing, tVETypeMapping, tEnergyCostResourceTypeMapping, tVETypeConfiguarations } from './glowadminservices/app-config.typings';
import { tAssetTypeConnectivityMapping, tDeviceTypeConnectivityMapping, tRefreshRateConfigurations } from './app-config.typings';


@Injectable()
export class ConfigService {

    private adminConfig: tAdminConfig;
    public supportedVETypes: tSupportedVETypeListing[];
    public resourceTypeMapping: tResourceTypeMapping;
    public resourceClassifierMapping: tResourceTypeMapping;
    public resourceEnergyCostMapping: tEnergyCostResourceTypeMapping[];
    public veTypeConfig: tVETypeConfiguarations;
    public veTypeMapping: tVETypeMapping;

    tempAccessAuthenticationTypeServiceName: string;

    constructor() { }

    loadTempAccessAuthServiceName() {
        this.tempAccessAuthenticationTypeServiceName = "temp-access";
        return this.tempAccessAuthenticationTypeServiceName;
    }
    public loadAdminConfig(): tAdminConfig {
        this.adminConfig = {
            "environment": {
                "baseEndpoint": "https://api.glowmarkt.com/api/v0-1/",
                rateLimitingHostUrl: "https://apil.glowmarkt.com/api/v0-1/",
                "authKeyword": "intauth",
                "userType": "internaluser"
            }
        };
        return this.adminConfig;
    }

    public getRefreshRateConfigurations(): tRefreshRateConfigurations {

        return {
            authCheck: 10 * 60 * 1000, // 10 minutes
            deviceStatusSummaryReport: 2 * 60 * 1000 // 2 minutes
        }
    }

    public loadResourceTypeMappings(): tResourceTypeMapping {
        this.resourceTypeMapping = {
            type: {
                electricity: ["45b6b096-1a23-4584-9a58-9631ea1f3274", "b5791d9a-6f58-4372-bae4-ae79d1cc0712", "23e9084a-19d4-4849-ab78-bd22753457f5", "9ec2bd19-bfa3-430b-9f08-9550c8cd4bbe", "bb0b2429-7776-44da-a3b4-f87ce3a47dd0", "ea02304a-2820-4ea0-8399-f1d1b430c3a0", "b4158501-a678-484a-837a-874194d3bd48", "b3c80261-f9d3-4453-a6e7-5fd02e89fc67", "c58b4039-3cdf-425a-873d-f9e82d8c4009", "b8a8b8ca-ee59-4fc9-97c1-77dfa6bd9b46", "177a0707-154b-4666-be59-2a5eff88a160"],
                gas: ["672b8071-44ff-4f23-bca2-f50c6a3ddd02", "32d9821b-34fd-46d1-9ba1-56259afd4734"],
                temperature: ["temperatureResourceTypeId", "5a0ac248-ab63-4bd7-9788-a9fa26b85c1a"],
                relativeHumidity: ["34b43bd1-d724-4c3f-954e-e74b5bbdcc7e"],
                daylight: ["dayightTimeSeriesResourceTypeId"],
                "consumption": ["45b6b096-1a23-4584-9a58-9631ea1f3274"],
                "generation": ["9b4ff990-60db-4d6c-9a0c-ab02bdd62fd3"],
                "diversion": ["7f464f1b-14ad-48a0-bc9d-0e464e9d6c36"],
                "import": ["d4181ac4-f182-412e-9106-3b298e0d4c62"],
                "export": ["20dc3d46-f07d-4d61-af52-b0ac148206bf"]
            },
            dimension: {
                energy: ["45b6b096-1a23-4584-9a58-9631ea1f3274", "b5791d9a-6f58-4372-bae4-ae79d1cc0712", "23e9084a-19d4-4849-ab78-bd22753457f5", "9ec2bd19-bfa3-430b-9f08-9550c8cd4bbe", "bb0b2429-7776-44da-a3b4-f87ce3a47dd0", "ea02304a-2820-4ea0-8399-f1d1b430c3a0", "672b8071-44ff-4f23-bca2-f50c6a3ddd02"],
                cost: ["b4158501-a678-484a-837a-874194d3bd48", "32d9821b-34fd-46d1-9ba1-56259afd4734", "b3c80261-f9d3-4453-a6e7-5fd02e89fc67", "c58b4039-3cdf-425a-873d-f9e82d8c4009", "b8a8b8ca-ee59-4fc9-97c1-77dfa6bd9b46", "177a0707-154b-4666-be59-2a5eff88a160"]
            }
        };
        return this.resourceTypeMapping;
    };

    public loadResourceClassiffierMappings(): tResourceTypeMapping {
        this.resourceClassifierMapping = {
            type: {
                electricity: ['electricity.consumption', 'electricity.consumption.cost'],
                gas: ['gas.consumption', 'gas.consumption.cost'],
                temperature: ["temperature"],
                relativeHumidity: ["relative_humidity"],
                daylight: ["dayight.normalization"],
                consumption: ["electricity.consumption"],
                generation: ["electricity.generation"],
                diversion: ["electricity.diversion"],
                import: ["electricity.import"],
                export: ["electricity.export"]
            },
            dimension: {
                energy: ['electricity.consumption', 'gas.consumption'],
                cost: ['electricity.consumption.cost', 'gas.consumption.cost']
            }
        };
        return this.resourceClassifierMapping;
    };

    public getSmartMeterCompatibleApplications() {
        return [
            {
                "applicationId": "b0f1b774-a586-4f72-9edd-27ead8aa7a8d",
                "name": "Bright",
            },


            {
                "name": "Energy Systems Catapult",
                "applicationId": "4cbec3ad-f4ff-4c6d-a93c-212f5c3c1a66"
            },
            {
                "applicationId": "e820bb20-7fb2-42f2-9e95-3ba65bc77ed6",
                "name": "Carbon Coop",
            },

            {
                "name": "ARM-Hub",
                "applicationId": "21fa14f5-4717-458e-a9ec-2464a1bb11d7",
            },
            {
                 "name": "Heatly Platform",
                    "applicationId": "7ad805e1-4eb1-426e-a825-f1664c728f5b"
            },
            {
                "applicationId": "469eceac-f596-4d8b-a775-3ec020393165",
                "name": "HUG2",
            },
            {
                "name": "Connected Response",
                "applicationId": "243ca878-6c7b-4253-8336-9ca97a5a3c15"
            },
            {
                "name": "My Smart Energy (Opus Energy)",
                "applicationId": "10d2d1e6-30ad-4ac9-8350-187c89840ba4",
            },
            {
                "name": "Assure (Opus Energy)",
                "applicationId": "a782d0c0-4816-463f-908b-c09ea88df91f",
            },
            {
                "name": "Assure (Drax)",
                "applicationId": "7837ed6f-a4b1-42cc-8a08-531038a3d73a",
            },
            {
                "name": "Drax Energy Assistant",
                "applicationId": "643864ad-99aa-40ec-b243-2514173bda54",
            },
            {
                "applicationId": "6dc7e58b-4f10-4897-9a6b-a0971bee1235",
                "name": "Smart Tariff Smart Comparison",
            },
            {
                "name": "UCL Interaction Team",
                "applicationId": "7d1d953d-427a-4678-ae2e-f856f4e070be",
            },

            {
                "applicationId": "4bf0129a-05f4-4f44-a836-6712b4fdc0d8",
                "name": "Parity Projects",
            },
            {
                "name": "Element Energy",
                "applicationId": "123a91f6-a7b7-471e-9abb-52de860725b3",
            },
            {
                "name": "Drax Consumption API",
                "applicationId": "b86e4f98-b000-4256-81c3-bd343a425a38",
            },
            {
                "name": "Pure Balance",
                "applicationId": "72c56d21-fae3-4492-9499-6e8d72e21154",
            },
            {
                "applicationId": "ff47e4d6-14b1-4e51-a46a-39a91268bd56",
                "name": "EnergyIQ",
            },
            {
                "applicationId": "8641ae75-573f-41a3-8403-a7f2afd06107",
                "name": "Samsung",
            },
            {
                "applicationId": "3e3e5463-afbd-4f7a-b57f-365e886cf914",
                "name": "RENEW Oxford",
            },
            {
                "applicationId": "c710f7de-7a26-4a32-86c8-cc01086e638f",
                "name": "Caring",
            },
            {
                "applicationId": "78c6f257-e4e1-462c-b9ff-2e1928637ae4",
                "name": "Power Transition Ltd (iMaas)",
            },
            {
                "applicationId": "e4753fdd-294f-437a-b3af-ce81b1ab9979",
                "name": "Eversmart",
            }, {

                "applicationId": "ae35ef49-805f-4022-9b24-fc3faa4fbac0",
                "name": "USIO",
            },
            {
                "applicationId": "b85d1263-04da-4e95-8a8d-e9a63d1210b7",
                "name": "UCL",
            },
            {
                "applicationId": "c2a92a4c-c829-4572-9333-292c370b6a82",
                "name": "UPower"
            },
            {
                "applicationId": "6ee27ea7-5808-4be4-a352-ba4ded79673e",
                "name": "USwitch"
            },
            {
                "applicationId": "562e2b90-f149-42dc-b03a-9aa8c6fd8239",
                "name": "BP"
            },
            {
                "applicationId": "3c06e609-29bd-487a-ada1-0a52bc1cce26",
                "name": "Low Carbon Hub"
            },
            {
                applicationId: "4819a54b-2048-4165-b557-7f0c35162bf3",
                name: "Heatio"
            },
            {
                applicationId: "1df32636-2cc2-46c4-9316-ab653a8d5c44",
                name: "Get Living"
            },
            {
                applicationId: "104a3c91-2e67-48f7-be48-a9d82a592ed6",
                name: "TFL"
            },
            {
                applicationId: "1f39e62a-edab-4ff0-860a-737652440c67",
                name: "Susy House"
            },
            {
                "name": "Purrmetrix",
                "applicationId": "12942ba2-86c8-462f-9bf8-59a3c298535f"
            }, 
            {
                "name": "BRE",
                "applicationId": "20858ce1-c3be-4fdf-b122-7bd2b0f6703d"
            },
            {
                "name": "Morgan Sindall",
                "applicationId": "e0c48f22-b893-4ed4-85f2-1665da0da790",
            },
            {
                "name": "Electralink (Test on Glow Prod)",
                "applicationId": "610eb6e2-8413-4b09-a60f-b38e49bf44b6",
            },
        ]
    }
};


@Injectable()
export class AssetTypeConfigService {

    //This service classifies the resource types as are required for the vatious vetypes
    assetTypeConnectivityMappings: tAssetTypeConnectivityMapping;

    getAssetTypeConnectivityConfigurations() {

        this.assetTypeConnectivityMappings = {
            connectivity: {
                wifi: ["ecf6a7e3-eff8-4e7d-af12-b24f23b7a5c7", "00012fd2-51b7-471e-965f-00e6535c0a37", "764ef28d-6cc5-48b2-8ab9-7a659d7ffb18", "07e1802c-d2af-47b9-bd11-c34e17a6301d"],
                ethernet: ["172b6b4b-aa59-463c-a3b6-117106dd0f36", "60619589-9249-4f04-9480-960faa5f9c18"]
            },
            wiFiPassword: {
                fixed: ["ecf6a7e3-eff8-4e7d-af12-b24f23b7a5c7", "00012fd2-51b7-471e-965f-00e6535c0a37"]
            },
            protocol: {
                openThings: ["ecf6a7e3-eff8-4e7d-af12-b24f23b7a5c7", "172b6b4b-aa59-463c-a3b6-117106dd0f36"],
                zigbee: ["60619589-9249-4f04-9480-960faa5f9c18", "00012fd2-51b7-471e-965f-00e6535c0a37", "764ef28d-6cc5-48b2-8ab9-7a659d7ffb18", "07e1802c-d2af-47b9-bd11-c34e17a6301d"]
            }
        }
        return this.assetTypeConnectivityMappings;
    }


    getDeviceEmails() {
        return { cad: ["GlowDisplayOnTheWayInstructions"] }
    }
}

@Injectable()

export class DeviceTypeConfigService {

    //This service classifies the resource types as are required for the vatious vetypes
    deviceTypeConnectivityMappings: tDeviceTypeConnectivityMapping;

    getDeviceTypeConnectivityConfigurations() {

        this.deviceTypeConnectivityMappings = {
            type: {
                "gateway": ["a6224773-f6de-4808-b422-dcf9cece1201", "9613ffb0-fb70-48fb-8927-4a936fd98c44", "00a5f229-ae7e-4ee0-bcf3-309b2211f3d5", "1027b6e8-9bfd-4dcb-8068-c73f6413cfaf", "b91cf82f-aafe-47f4-930a-b2ed1c7b2691", "7adcd7d3-3cd5-4c6d-882d-e5af636cc46f"],
                "sensors": ["1ff18981-76ab-4f54-ba5c-eba107e1d6d2"]
            },
            connectivity: {
                wifi: ["9613ffb0-fb70-48fb-8927-4a936fd98c44", "1027b6e8-9bfd-4dcb-8068-c73f6413cfaf", "b91cf82f-aafe-47f4-930a-b2ed1c7b2691", "7adcd7d3-3cd5-4c6d-882d-e5af636cc46f"],
                ethernet: ["a6224773-f6de-4808-b422-dcf9cece1201", "00a5f229-ae7e-4ee0-bcf3-309b2211f3d5"]
            },
            protocol: {
                openThings: ["9613ffb0-fb70-48fb-8927-4a936fd98c44", "a6224773-f6de-4808-b422-dcf9cece1201"],
                zigbee: ["00a5f229-ae7e-4ee0-bcf3-309b2211f3d5", "1027b6e8-9bfd-4dcb-8068-c73f6413cfaf", "b91cf82f-aafe-47f4-930a-b2ed1c7b2691", "7adcd7d3-3cd5-4c6d-882d-e5af636cc46f"]
            }
        };
        return this.deviceTypeConnectivityMappings;
    }
}


